<template>
    <div id="app">
        <v-app id="inspire">
            <v-layout wrap>
            
            <!-- maps page toolbar location -->
            <v-toolbar v-model="locationDialog" flat class="mt-5 elevation-1 hidden-md-and-up ma-0 pa-0 pt-0 title deep-orange  font-weight-regular white--text" @click="(useCurrentLoc(),attemp=1)">Use my current location <v-spacer></v-spacer><v-icon class="white--text">my_location</v-icon> 
            </v-toolbar>
            
            <!-- landing page toolbar location -->
            <v-flex>
                <v-text-field class="font-weight-regular ma-0 pa-0 hidden-md-and-up" v-model="formattedAddress" :hide-details="true" solo label="Enter Place or Branch" append-icon="search" @click:append="(geoCoding())" @keyup.enter="(geoCoding())"></v-text-field>
            </v-flex>
            
            <v-dialog content-class="locationDialog hidden-sm-and-down" v-model="locationDialog" width="400" height="100" hide-overlay persistent>  
                <v-card-title height=10 class="display-2 font-weight-light white--text">Book Appointment
                </v-card-title>
                
                <v-card-title height=10 class="title deep-orange  font-weight-light white--text" @click="(useCurrentLoc(),attemp=1)">
                    <v-icon class="white--text">my_location</v-icon> Use my current location
                </v-card-title>
                
                <v-flex>
                    <v-text-field class="font-weight-regular" :hide-details="true" v-model="formattedAddress" solo label="Enter Place or Branch" append-icon="search"  height="60"  @click:append="(geoCoding())" @keyup.enter="(geoCoding())">
                    </v-text-field>
                </v-flex>
            </v-dialog>

            <v-carousel hide-controls v-if="showBg" height="auto" class="hidden-sm-and-down">
                <v-carousel-item v-for="(item,i) in gallery" :key="i">
                    <img contain width="100%" :src="item.src">
                </v-carousel-item>
            </v-carousel>

            <v-carousel hide-controls v-if="showBg" height="auto" class="hidden-md-and-up">
                <v-carousel-item v-for="(item,i) in gallery" :key="i">
                    <img contain width="100%" :src="item.src">
                </v-carousel-item>
            </v-carousel>
            
            <v-flex xs12 md12 lg12>
                <v-footer dark height="auto" v-if="showBg" >
                    <v-card flat tile class="blue-grey darken-4 white--text text-xs-center" width="100%">
                        <br>
                        <v-card-text class="display-1 white--text pt-0">
                            Our Brands
                            <v-layout>
                                <v-flex xs12 sm6 offset-sm3>
                                    <v-card class="blue-grey darken-4" flat>
                                        <v-layout>
                                            <v-flex v-for="(item,n) in logo" :key="n" xs4 d-flex>
                                                <v-card flat>
                                                    <v-img class="blue-grey darken-4" contain width="100%" :src="item.src" aspect-ratio="1" > </v-img>
                                                </v-card>
                                            </v-flex>
                                        </v-layout>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </v-card-text>

                        <v-card flat tile class="blue-grey darken-4 white--text text-xs-center" width="100%">
                            <v-expansion-panel>
                                <v-expansion-panel-content class="blue-grey darken-4 white--text text-xs-center display-1">
                                    <template v-slot:header>
                                        <v-card-text class="blue-grey darken-4 white--text text-xs-center display-1">Our Services</v-card-text>
                                    </template>

                                    <v-container grid-list-sm fluid>
                                        <v-layout row wrap>
                                            <v-flex xs12 v-for="(category,index) in serviceCategory" :key="index" class="pt-0 pl-3 ">
                                                <v-expansion-panel>
                                                    <v-expansion-panel-content class="blue-grey darken-4">
                                                        <template v-slot:header>
                                                            <div class="subheading font-weight-black text-uppercase">{{category}}</div>
                                                        </template>

                                                        <v-flex xs12 v-for="service in serviceMenu" :key="service.id" class="pt-0 pl-3" v-if="service.category==category">
                                                            <v-card-title class="subheading font-weight-regular pt-0 pb-0 pl-3">{{service.serviceName}}
                                                            </v-card-title>
                                                            <v-card-title class="caption font-weight-regular pt-0 pl-5">{{service.description}}
                                                            </v-card-title>
                                                        </v-flex>
                                                    </v-expansion-panel-content>
                                                </v-expansion-panel>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-card>
                        <v-divider></v-divider>
                    </v-card>
                </v-footer>
            </v-flex>

            <v-flex xs12 md12 lg12>
                <v-footer dark height="auto" v-if="showBg" >
                    <v-card flat tile class="blue-grey darken-4 white--text text-xs-center" width="100%">
                        <v-divider></v-divider>
                        <v-card-text class="white--text">
                        &copy;2020 — Service Scheduler. All Rights Reserved.<strong></strong>
                        </v-card-text>
                    </v-card>
                </v-footer>
            </v-flex>

            <GmapMap v-if="showMap" :center="{lat: mapLat, lng: mapLng}" :zoom="13" class="hidden-sm-and-down"
                map-type-id="roadmap" style="width: 100%; height: 700px"
                :options="{zoomControl: true, mapTypeControl: false, scaleControl: false, streetViewControl: false, rotateControl: false, fullscreenControl: true, disableDefaultUi: true}">

                <v-dialog content-class="mapDialog  hidden-sm-and-down" v-model="mapDialog" width="400" height="100" hide-overlay persistent> 
                    <v-card-title class="title deep-orange  font-weight-regular white--text" @click="(useCurrentLoc(),attemp=1)">
                    <v-icon class="white--text">my_location</v-icon> Use my current location
                    </v-card-title>
            
                    <v-flex>
                        <v-text-field class="font-weight-regular" :hide-details="true" v-model="formattedAddress" solo label="Enter Place or Branch" append-icon="search" @click:append="geoCoding()" @keyup.enter="geoCoding()" height=60 ></v-text-field>
                    </v-flex>
                </v-dialog>

                <v-dialog content-class="detailsDialog hidden-sm-and-down" v-model="detailsDialog" width="400px" height="100px" hide-overlay persistent>  
                    <v-toolbar class="subheading deep-orange  font-weight-regular" dense>
                    <v-toolbar-title class="subheading deep-orange  font-weight-regular white--text">Branch Information</v-toolbar-title>
                    </v-toolbar>
                    <v-list style="max-height:330px; overflow-y: auto;" content-class="listInfo" three-line subheader expand light>
                        <template v-for="(list, index) in sortBranches">
                            <v-list-tile :key="index">
                                <v-list-tile-content>
                                    <v-list-tile-title >{{ list.businessUnit }}</v-list-tile-title>
                                    <v-list-tile-sub-title>{{ list.address }}</v-list-tile-sub-title>
                                    <v-list-tile-sub-title>Distance : {{ list.distance.toFixed(2) }} km</v-list-tile-sub-title>
                                </v-list-tile-content>

                                <v-list-tile-action class="caption font-weight-regular">
                                    <!-- <div v-if="user==null">
                                        <v-btn flat color="primary" @click="checkBranchAccess(list)">Book</v-btn>
                                    </div> -->

                                    <div v-if="user==null">
                                        <div v-if="list.status==true">
                                            <v-btn flat color="primary" @click="(checkBranchAccess(list))">Book</v-btn>
                                        </div>     
                                    </div>

                                    <div v-else>
                                        <div v-if="list.status==true">
                                            <v-btn flat color="primary" @click="(checkBranchAccess(list))">Book</v-btn>
                                        </div>     
                                    </div>
                                </v-list-tile-action>
                            </v-list-tile>
                        <v-divider v-if="index + 1 < sortBranches.length" :key="list.branchCode"></v-divider>
                        </template>
                    </v-list>
                </v-dialog>

                <v-menu offset-x>
                    <template v-slot:activator="{ on }">
                        <gmap-marker
                            v-for="(list,index) in businessUnits" :key="index"
                            :position="google && new google.maps.LatLng(list.latitude, list.longitude)" :clickable="true"
                            :label="list.businessUnit"
                            @click="(center=google && new google.maps.LatLng(list.latitude, list.longitude))" icon="https://img.icons8.com/color/48/000000/marker.png"
                        ></gmap-marker>
                    </template>
                </v-menu>
            </GmapMap>

            <GmapMap v-if="showMap" :center="{lat: mapLat, lng: mapLng}" :zoom="11" class="hidden-md-and-up"
                map-type-id="roadmap" style="width: 100%; height: 300px"
                :options="{zoomControl: true, mapTypeControl: false, scaleControl: false, streetViewControl: false, rotateControl: false, fullscreenControl: true, disableDefaultUi: true}">

                <v-dialog content-class="mapDialog  hidden-sm-and-down" v-model="mapDialog" width="400" height="100" hide-overlay persistent> 
                    <v-card-title class="title deep-orange font-weight-regular white--text" @click="(useCurrentLoc(),attemp=1)">
                        <v-icon class="white--text">my_location</v-icon> Use my current location
                    </v-card-title>
            
                    <v-flex>
                        <v-text-field class="font-weight-regular" :hide-details="true" v-model="formattedAddress" solo label="Enter Place or Branch" append-icon="search" @click:append="geoCoding()" @keyup.enter="geoCoding()" height=60 ></v-text-field>
                    </v-flex>
                </v-dialog>

                <v-menu offset-x>
                    <template v-slot:activator="{ on }">
                        <gmap-marker
                            v-for="(list,index) in businessUnits" :key="index"
                            :position="google && new google.maps.LatLng(list.latitude, list.longitude)" :clickable="true"
                            @click="(center=google && new google.maps.LatLng(list.latitude, list.longitude))" icon="https://img.icons8.com/color/48/000000/marker.png"
                            :label="list.BusinessUnit"
                        ></gmap-marker>
                    </template>
                </v-menu>
            </GmapMap>
            </v-layout>

            <v-layout row justify-center>
                <v-snackbar class="font-weight-medium" v-model="showAlert" :color="alertColor" right bottom>
                    {{showAlertMessage}}
                    <v-btn small color="white" flat @click="showAlert = false"> Close </v-btn>
                </v-snackbar>

                <v-dialog  v-model="showProgress" persistent width="300">
                    <v-card color="blue-grey darken-4">
                        <v-card-text class="subheading white--text"> {{progressMessage}}
                            <v-layout row justify-center>
                            <v-progress-linear :indeterminate="true" :size="70" :width="5" color="white"
                            ></v-progress-linear>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </v-layout>

            <v-layout v-show="mapsBranchInfo" class="hidden-md-and-up">
                <v-flex xs12>
                    <v-toolbar class="subheading deep-orange  font-weight-regular" dense>
                    <v-toolbar-title class="subheading deep-orange  font-weight-regular white--text">Branch Information</v-toolbar-title>
                    </v-toolbar>
                </v-flex>
            </v-layout>
            
            <v-layout v-show="mapsBranchInfo" class="hidden-md-and-up">
                <v-flex xs12>
                <v-list style="max-height:330px; overflow-y: auto;" content-class="listInfo" three-line subheader expand light>
                    <template v-for="(list, index) in sortBranches">
                        <v-list-tile :key="index">
                            <v-list-tile-content>
                                <v-list-tile-title >{{ list.businessUnit }}</v-list-tile-title>
                                <v-list-tile-sub-title>{{ list.address }}</v-list-tile-sub-title>
                                <v-list-tile-sub-title>Distance : {{ list.distance.toFixed(2) }} km</v-list-tile-sub-title>
                            </v-list-tile-content>

                            <v-list-tile-action class="caption font-weight-regular">
                                <!-- <div v-if="user==null">
                                    <v-btn flat color="primary" @click="checkBranchAccess(list)">Book</v-btn>
                                </div> -->

                                <div v-if="user==null">
                                    <div v-if="list.status==true">
                                        <v-btn flat color="primary" @click="(checkBranchAccess(list))">Book</v-btn>
                                    </div>     
                                </div>

                                <div v-else>
                                    <div v-if="list.status==true">
                                        <v-btn flat color="primary" @click="(checkBranchAccess(list))">Book</v-btn>
                                    </div>     
                                </div>
                                
                                <!-- <div v-else-if="user.mobileNumber">
                                    <div>
                                        <v-btn flat color="primary" @click="(checkBranchAccess(list))">Book</v-btn>
                                    </div>     
                                </div> -->

                                <!-- <div v-else-if="user.mobileNumber==''">
                                    <v-btn flat color="primary" @click="showAlert=true,alertColor='red accent-4',showAlertMessage='Please update your profile information'">Book</v-btn>
                                </div> -->
                            </v-list-tile-action>
                        </v-list-tile>
                    <v-divider v-if="index + 1 < sortBranches.length" :key="list.branchCode"></v-divider>
                    </template>
                </v-list>
                </v-flex>
            </v-layout>
            <v-dialog v-model="updateInfoDialog" persistent max-width="800px">
                <profile-component></profile-component>
            </v-dialog>
        </v-app>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex"
import {db} from '../main'
import { gmapApi } from "vue2-google-maps"
import geolocation from 'vue-geolocation-api'
import profileComponent from './Profile.vue'

export default {
    components: {
        profileComponent,
    },
    data: () => ({
        formattedAddress: "",
        businessUnits: [],
        showMap: false,
        showBg: true,
        locationDialog: true,
        detailsDialog: false,
        nearestbranch: {},
        sortBranches: [],
        currentPosition: {
            lat: null,
            lng: null
        },
        mapLat: 0,
        mapLng: 0,
        mapDialog: false,
        gallery: [
            // {src: require('../img/01_slides.png')},
            // {src: require('../img/02_slides.png')},
            // {src: require('../img/03_slides.png')},
            // {src: require('../img/04_slides.png')},
            // {src: require('../img/05_slides.png')},
            {src: require('../img/SERVICE-SCHEDULER-BANNER.png')}
        ],
        logo: [
            {src: require('../img/New Project (5).png')},
            {src: require('../img/New Project (6).png')},
            {src: require('../img/New Project (7).png')},
            {src: require('../img/New Project (8).png')},
            {src: require('../img/New Project (9).png')},
        ],
        mapsBranchInfo: false,
        showAlert: false,
        showAlertMessage: "",
        branchWithAccess: [],
        alertColor: "",
        attemp: 0,
        progressMessage: "",
        showProgress: false,
        serviceMenu: [],
        serviceCategory: [
            "Tune Up",
            "Carburator & Fuel Injection System",
            "Top Overhauling",
            "Major Overhauling",
            "Side Overhauling",
            "Oil Seals",
            "Brake System",
            "Steering System",
            "Cables",
            "Drive Chain & V-Belt",
            "Front and Rear Wheel",
            "Electrical Wiring",
            "Other Services"
        ],
        updateInfoDialog: false,
        materialMaster: [],
}),

    methods : {
        openProfileDialog() {
            this.$store.dispatch("setProfile", "1")
            this.updateInfoDialog = true
        },

        closeProfileDialog() {
            this.$store.dispatch("setProfile", "0")
            this.updateInfoDialog = false
        },
        // ********* FETCH ALL BRANCHES *************
        async fetchBranches() {
            let self = this 
            let branches = []
            
            self.progressMessage = "Loading..."
            self.showProgress = true
            await db.collection("Branches"+self.$stage)
                .get().then(function(querySnapshots) {
                    querySnapshots.forEach(function(doc) {
                        if (doc.data().latitude !== "" && doc.data().longitude !== ""){
                            branches.push(doc.data())
                        }
                    })
                }).then(function(){
                    self.businessUnits = []
                    for(let i = 0; i < branches.length; i++){
                        let branch = branches[i]
                        let distance = getDistanceFromLatLonInKm({
                            latitude: self.currentPosition.lat,
                            longitude: self.currentPosition.lng
                        },
                        {
                            Latitude: branch.latitude,
                            Longitude: branch.longitude
                        })
                        branch.distance = distance
                        if (!isNaN(branch.distance)) {
                            self.businessUnits.push(branch)  
                        }
                    }
                    self.businessUnits = _.uniqBy(self.businessUnits, 'branchCode')
                    self.sortToNearest()
                    self.progressMessage = ""
                    self.showProgress = false  
                }).catch(error => {console.log(error)})
        },

        // ********* CHECK BRANCH ACCESS *******************
        checkBranchAccess(check) {
            let self = this
            let mechanics = []
            let count = 0
            self.branchWithAccess = []

            db.collection("Mechanics"+self.$stage)
                .where("branchId","==",check.id)
                .where("tag","==",true)
                .where("status","==","Active")
                .get().then(function(snapshot) {
                    snapshot.forEach(function(doc) {
                        mechanics.push(doc)
                    })
                }).then(function() {
                    if (mechanics.length > 0) {
                        if (self.user) {
                            self.goToPage(`service-scheduler/${check.businessUnit}/${check.branchCode}/${check.id}/2`)
                        } else {
                            localStorage.setItem("redirect", `${window.location.origin}/service-scheduler/${check.businessUnit}/${check.branchCode}/${check.id}/2`);
                            self.$router.push(`/service-scheduler/${check.businessUnit}/${check.branchCode}/${check.id}/2`)
                        }
                        
                    } else {
                        self.showAlert=true
                        self.alertColor = "red accent-4"
                        self.showAlertMessage= check.businessUnit + " is not yet available for service scheduler application. You can visit us at store."
                    }
                })  
        },

        // ********* COMPUTATION OF LAT & LANG *************
        closestLocation(targetLocation, locationData) {
            return locationData.reduce(function(prev, curr) {
                let prevDistance = locationDistance(targetLocation, prev),
                    currDistance = locationDistance(targetLocation, curr)
                return (prevDistance < currDistance) ? prev : curr
            })
        },

        // ********* ARRANGEMENT OF LIST OF BRANCHES FROM NEAREST *************
        sortToNearest() {
            let self = this
            self.sortBranches = _.sortBy(self.businessUnits, ['distance'])
        },
        
        // ********* CONVERT INPUTED LOCATION TO COORDINATES *************
        geoCoding() {
            let self = this
            let geoCoordinates = []
            let url = "https://maps.googleapis.com/maps/api/geocode/json?address="+self.formattedAddress+"&key=AIzaSyDHAjcezNBpAbyyj9PwSnH5fplYE1o9cOE"
            self.sortBranches = []
            let instance = self.$axios.create()
            instance.defaults.headers.common = {}

            if (self.formattedAddress !== "") {
                self.$axios.get(url).then(result => {
                    if(self.currentPosition) {                
                    } else {
                        self.currentPosition = Array()  
                    }
                    result.data.results.forEach(function(doc){
                        geoCoordinates.push(doc.geometry)
                    })
                    self.currentPosition.lat = geoCoordinates[0].location.lat,
                    self.currentPosition.lng = geoCoordinates[0].location.lng
                    setTimeout(() => {
                        self.fetchBranches()
                        self.showMap=true
                        self.showBg=false
                        self.detailsDialog=true
                        self.locationDialog=false
                        self.mapDialog=true
                        self.mapsBranchInfo=true
                    }, 1000)  
                })
            } else {
                self.showAlert=true
                self.alertColor = "red accent-4"
                self.showAlertMessage = "Please input preferred location."
            }
        },

        // ********* FETCH CURRENT LOCATION *************
        useCurrentLoc() {
            let self = this
            let currentAddress = []
            let encodeUrl = encodeURI(self.formattedAddress)
            let url ="https://us-central1-servicescheduler-af9f2.cloudfunctions.net/reverse_geocoder" 

            self.$geolocation.getCurrentPosition().then(result => {
                if (result.coords) {
                    self.currentPosition = {
                        lat: result.coords.latitude,
                        lng: result.coords.longitude,
                    }
                    let body = {
                        'lat': self.currentPosition.lat,
                        'lng': self.currentPosition.lng
                    }  
                    self.mapLat = self.currentPosition.lat
                    self.mapLng = self.currentPosition.lng
                    self.$axios.post(url,body).then(result => {
                        result.data.forEach(function(doc){
                            currentAddress.push(doc.formatted_address)
                        })
                        self.formattedAddress = currentAddress[0]
                        self.fetchBranches()
                        self.showProgress = false
                    }).then(function(){
                        if (self.attemp === 1) {
                            self.showMap=true
                            self.showBg=false
                            self.detailsDialog=true
                            self.locationDialog=false
                            self.mapDialog=true
                            self.mapsBranchInfo=true
                        }
                    })  
                }
            }).catch(function(error) {
                if (error.code == error.PERMISSION_DENIED) {
                    self.currentPosition = null
                    if (self.attemp === 1 && self.currentPosition === null) {
                        self.showAlert=true
                        self.alertColor = "red accent-4"
                        self.showAlertMessage = "Please allow your location to proceed."
                    }
                }
            })
        },

        // ********* R O U T E ***********
        goToPage(page) {
            this.$router.push("/"+page)
        },

        async fetchServiceMenu() {
            let self = this
            self.serviceMenu = []   

            await db.collection("ServiceMenu"+self.$stage).get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc){
                    if (doc.data().status == "active") {
                        self.serviceMenu.push(doc.data())
                    }
                })
            }).then(function(){
                self.serviceMenu.sort()
            }).catch(function(error){
                self.showAlert = true
                self.alertColor = "red accent-4"
                self.showAlertMessage="Error fetching document"
            })
        },

        async fetchNetsuiteMaterialMaster() {
            let self = this
            self.materialMaster = []
            self.$axios.defaults.headers.common['Authorization']=`NSJ ${self.$consumerKey}&${self.$consumerSecret}`
            self.$axios.defaults.headers.common['ns-token']= self.$tokenId
            self.$axios.defaults.headers.common['ns-token-secret']= self.$tokenSecret
            self.$axios.defaults.headers.common['Content-Type']= self.$contentType
            
            await self.$axios.get(self.$materialMaster).then(function(res){
                res.data.data.forEach(function(result) {
                    let code = {
                        'BUSINESS': 'Business',
                        'SOLO/CUB/MOPED': 'CUB',
                        'SCOOTER/AUTOMATIC': 'Automatic',
                        'SPORTS/STREET': 'Hi-End'
                    }

                    for (let key in code) {
                        let re = new RegExp(key, 'gi')
                        result.values["custitem_item_industryclassification"][0]["text"] = result.values["custitem_item_industryclassification"][0]["text"].replace(re, code[key])
                    }

                    result.values.manufacturer = result.values.manufacturer.toLowerCase()
                    
                    if (result.values["custitem_item_description"].length) {
                        self.materialMaster.push({
                            id: result.id,
                            classification: result.values["custitem_item_industryclassification"][0]["text"],
                            brand: result.values.manufacturer.charAt(0).toUpperCase() + result.values.manufacturer.slice(1),
                            model: result.values["custitem_item_description"][0]["text"]
                        })
                    }
                })
            }).then(function() {
                self.materialMaster = _.uniqBy(self.materialMaster, 'model');
                self.clone()
            }).catch(function(error) {
                console.error("Error getting document: ", error)
            })
        },

        clone() {
            let self = this
            self.materialMaster.forEach(function(data) {
                console.log(data)
                db.collection("Motorcycles").doc(data.id).set({
                    "id": data.id,
                    "model": data.model,
                    "classification": data.classification,
                    "brand": data.brand,
                    "status": true
                }).then(function() {
                    console.log("Updated Successfully")
                }).catch(function(error) {
                    console.error("Error writing document: ", error)
                })
            })
        },
    },

    mounted() {
        let self = this
        self.useCurrentLoc()
        self.fetchServiceMenu()
        // self.fetchNetsuiteMaterialMaster()
    },

    computed: {
        google: gmapApi,
        ...mapGetters(["user"]),
        ...mapState(["Auth"]),
    },

    watch: {
        businessUnits(newValue) {
            this.nearestbranch = this.closestLocation({ latitude: this.currentPosition.lat, longitude: this.currentPosition.lng }, newValue)
            this.mapLat = parseFloat(this.nearestbranch.latitude)
            this.mapLng = parseFloat(this.nearestbranch.longitude)
        },

        currentPosition: {
            handler: function(newValue) {
                try {
                    this.nearestbranch = this.closestLocation({ latitude: this.currentPosition.lat, longitude: this.currentPosition.lng }, this.businessUnits)
                    this.mapLat = parseFloat(this.nearestbranch.latitude)
                    this.mapLng = parseFloat(this.nearestbranch.longitude)
                } catch (error) {}   
            },
            deep: true
        },

        Auth: {
           handler: function(newValue) {
                let self = this
                if (self.Auth.profileComponent == "1") {
                    self.updateInfoDialog = true
                    console.log("open")
                } else if  (self.Auth.profileComponent == "0") {
                    self.updateInfoDialog = false
                    console.log("close")
                }
           },
           deep: true
        },
    }
}

function vectorDistance(dx, dy) {
    return Math.sqrt(dx * dx + dy * dy)
}

function locationDistance(location1, location2) {
    let dx = location1.latitude - location2.latitude,
        dy = location1.longitude - location2.longitude
    return vectorDistance(dx, dy)
}

// ********* GETTING THE KM DISTANCE PER BRANCH *************
function getDistanceFromLatLonInKm(location1, location2) {
    let R = 6371 // Radius of the earth in km
    let dLat = deg2rad(location2.Latitude-location1.latitude)  // deg2rad below
    let dLon = deg2rad(location2.Longitude-location1.longitude) 
    let a = 
        Math.sin(dLat/2) * Math.sin(dLat/2) +
        Math.cos(deg2rad(location1.latitude)) * Math.cos(deg2rad(location2.Latitude)) * 
        Math.sin(dLon/2) * Math.sin(dLon/2)
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a))
    let d = R * c // Distance in km
    return d
}

function deg2rad(deg) {
  return deg * (Math.PI/180)
}

</script>

<style>
    .locationDialog {
        position: absolute;
        top: 110px;
        left: 0px;
    }
    .mapDialog {
        position: absolute;
        top: 135px;
        left: 0px;
    }

    .detailsDialog {
        position: absolute;
        top: 280px;
        left: 0px;
    }

    #logo-container {
    	margin-right: 50px;
    }

    #logo-container img {
        height: 50px;
        width:auto;
        border-radius: 10%;
    }
    
    a {
    text-decoration: none;
    }

    .fit {
        max-width: 100%;
        max-height: 100%;
    }
    .gm-style-mtc {
        display: none;
    }
 
</style>
